// extracted by mini-css-extract-plugin
module.exports = {"loginBanner":"LoginBanner_loginBanner__ocoiQ","loginButton":"LoginBanner_loginButton__lWPdA"};